'use strict';

import { Card, Col, Form, Row, Select } from 'antd';
import React from 'react';
import { copy, ObjFactory, PrmFactory, uuid } from 'rt-sd-common';
import { convertModuleByGuid } from 'rt-sd-comp';
const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout2 = {
	labelCol: { span: 23 },
	style: {
		width: "100%",
		margin: "1px -7px 1px auto"
	}
};
const formItemLayout3 = {
	labelCol: { span: 14 },
	wrapperCol: { span: 10 },
};

function getCheckedItems(prm) {
	let checkeds = [];
	const cldSet = prm.cldSet || [];
	cldSet.forEach(cld => {
		if (cld.nodeType === "item" || cld.nodeType === "tag") {
			if (cld._checked) {
				// checkeds.push({
				//     tagId: cld.id,
				//     matchType: cld.defaultMatchType,
				//     // featureValue: cld.id,
				// });
				checkeds.push(cld);
			}
		} else if (cld.cldSet) {
			checkeds.push(...getCheckedItems(cld));
		}
	});
	return checkeds;
}

function getExpressOptions() {

	let expressSC = StandardCode.getSC(custGroupConfig.matchTypePrm);

	if (!expressSC) {
		return <Option value="">不存在</Option>
	}

	let expressOptions = [];
	expressSC.forEach(element => {
		expressOptions.push(<Option value={element.c}>{element.ann}</Option>)
	});

	return expressOptions;
}

function getExpressText(c) {
	let expressSC = StandardCode.getSC(custGroupConfig.matchTypePrm);

	if (!expressSC) return c;

	let text = c;
	expressSC.some(item => {
		if (item.c === c) {
			text = item.ann;
			return true;
		}
	});

	return text;
}

export default class CustQueryCondition extends React.Component {
	constructor(props) {
		super(props);

		let objFct = new ObjFactory("CustQueryCondition");

		// let prm = PrmFactory.getPrm(custGroupConfig.custQueryPrmDef);
		let prm = PrmFactory.getPrm("Emos_param_custAdvQuery_0001");
		const allData = prm.cldSet || [];

		const checkeds = getCheckedItems(prm);

		this.state = {
			forms: {}, //客群定义显示form，一个属性一个form,{key:form,key2:form2}
			formsValue: {},
			showCtls: {}, //存储所有显示控件
			objFct: objFct,
			loading: false,
			checkedAtts: {},
			allData: allData,
			data: this.props.data || checkeds || [],
		};

		// 创建所有forms
		this.createForms(checkeds);
	}

	convertData = (e) => {
		//校验 组装数据
		let errors = [];
		let errorMsg;
		for (var tmpKey in this.state.showCtls) {
			let tmpCtl = this.state.showCtls[tmpKey];
			let ctlDisplay = this.state.formsValue[tmpCtl.props.moduleDesc.cRef]["ctl2Display"];
			if (ctlDisplay != 'none') {
				errorMsg = tmpCtl.validate();
				if (errorMsg) {
					errors.push(errorMsg);
				}
			}
		}

		if (errors.length > 0) {
			//组装数据
			this.setState({ loading: false })
			// alert('校验失败');//这里不用提示，组件自身提示
			return null;
		}

		let data = [];
		for (var tmpKey in this.state.checkedAtts) {
			let tmpSaveRecord = this.state.objFct.get(tmpKey + "_tmp");
			if (!tmpSaveRecord.value1 && !tmpSaveRecord.value1) continue;
			let matchType = tmpSaveRecord.match_type;
			let value = tmpSaveRecord.value1;
			if (matchType == "Between" || matchType == "NotBetween") {
				value += "," + tmpSaveRecord.value2;
			}
			let obj = {
				tagId: tmpSaveRecord.id,
				tagName: tmpSaveRecord.te,
				matchType: matchType,
				valueType: tmpSaveRecord.valueType || "01",
				featureValue: value,
				tagCode: tmpSaveRecord.c
			};
			data.push(obj);
		}
		tool.sgiLogger.info(data);

		return data;

	}

	refreshData = (data) => {

		if (!data) return;
		const { allData } = this.state;

		//重置
		// this.state.forms = { ...this.state.forms };
		this.state.forms = {};
		// this.state.formsValue = {};
		// this.state.showCtls = {};

		data.forEach(item => {
			item.tagId = item.tagId || item.featureTagId || item.id;
			for (const gr of allData) {
				if (!gr.cldSet) continue;
				for (const rec of gr.cldSet) {
					if (item.tagId == rec.id) {
						let matchType = item.matchType || item.defaultMatchType;
						let ctl2Display = "none";
						let value = item.featureValue || item.defVal10;
						let value1 = value, value2;
						if (matchType == "Between" || matchType == "NotBetween") {
							ctl2Display = undefined;
							let values = (value || "").split(",");
							value1 = values[0];
							value2 = values[1];
						}
						this.state.formsValue[rec.c] = { ...rec, match_type: matchType, ctl2Display: ctl2Display, value1: value1, value2: value2 };
						this.createFormInfo(rec, matchType, value1, value2);
						break;
					}
				}
			}
		});
		this.setState({ data });
	}

	handleChange(attc, match_type, dataRef, value) {
		tool.sgiLogger.info(`selected ${attc}`);
		tool.sgiLogger.info(`selected ${match_type}`);
		tool.sgiLogger.info(`selected ${value}`);

		if (value == "Between" || value == "NotBetween") {
			this.state.formsValue[attc]["ctl2Display"] = undefined;
		} else {
			this.state.formsValue[attc]["ctl2Display"] = 'none';
		}
		this.state.formsValue[attc][match_type] = value;
		this.createFormInfo(dataRef, value); //重新创建
		this.setState({ loading: false })
	}

	createForms = (data) => {
		data.forEach(item => {
			const c = item.c;
			if (!c) return;
			const match_type = item.defaultMatchType || "EqualTo";
			const ctl2Display = (match_type == "Between" || match_type == "NotBetween") ? undefined : "none";
			this.state.formsValue[c] = { ...item, match_type: match_type, ctl2Display: ctl2Display };
			this.createFormInfo(item, item.defaultMatchType);
		});
	}

	createFormInfo(dataRef, matchType, value1, value2) {

		dataRef.desId = dataRef.desId || "EP_EO_UI_3101";//添加默认值-文本框
		let moveStyle = {};
		if (dataRef.desId === "EP_EO_UI_3101" && dataRef.bdText) {
			// 文本组件存在后置文本时需要进行偏移，这是antd的bug，修复后这里可以取消
			moveStyle.marginTop = 4;
			moveStyle.marginBottom = -4;
		}

		let attc = dataRef.c;
		let text = dataRef.te;

		let bdInst = attc + "_tmp";

		let ctl2ShowFlg = false;

		//显示的所有属性的集合
		this.state.checkedAtts[attc] = true;

		this.state.objFct.set(bdInst, this.state.formsValue[attc]);

		//修改c值，给每组值起同样的key
		dataRef.cRef = attc;
		let dataRef1 = copy(dataRef);
		dataRef1.c = "value1";
		dataRef1.isLbl = true;
		if (value1) dataRef1.value = value1;
		let ctl1 = convertModuleByGuid(this, dataRef1, bdInst, this.state.objFct, "N");
		ctl1.ref = this.refModalFunction.bind(this);
		let dataRef2 = copy(dataRef);
		dataRef2.c = "value2";
		// dataRef2.isLbl = false;
		// dataRef2.te = '-';
		dataRef2.isLbl = true;
		dataRef2.ctlW = 24;
		dataRef2.lblW = 2;
		// dataRef2.alwBlk = true;
		if (value2) dataRef2.value = value2;
		let ctl2 = convertModuleByGuid(this, dataRef2, bdInst, this.state.objFct, "N");
		if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
			ctl2.ref = this.refModalFunction.bind(this);
			ctl2ShowFlg = true;
		} else {
			delete ctl2.ref;
			ctl2ShowFlg = false;
		}

		let ctl1Span = 5;
		if (matchType && (matchType == "In" || matchType == "NotIn")) {
			ctl1Span = 11;
		}
		if (!ctl2ShowFlg) {
			ctl1Span = 11;
		}

		this.state.forms[attc] = <Row key={uuid(8)}>
			<Col span={dataRef.matchDis ? 7 : 12}>
				{/* <Col xs={{ span: 5, offset: 1 }} lg={{ span: 6, offset: 2 }}> */}
				<FormItem style={{ 'margin-bottom': "1px", 'margin-top': "1px" }} {...(dataRef.matchDis ? formItemLayout2 : formItemLayout3)} hasFeedback={false} label={text}>
					{dataRef.matchDis ?
						null// getExpressText(this.state.formsValue[attc]["match_type"])
						:
						<Select disabled={dataRef.matchDis} value={this.state.formsValue[attc]["match_type"]} style={{ width: '100%' }} onChange={this.handleChange.bind(this, attc, "match_type", dataRef)}>
							{getExpressOptions()}
						</Select>
					}
				</FormItem>
			</Col>
			{dataRef.matchDis ? null : <Col span={1}></Col>}
			<Col span={ctl1Span}>
				<div style={{ ...moveStyle, float: "left", width: "100%" }}>{ctl1}</div>
			</Col>
			{/* <Col span={1} style={{ display: this.state.formsValue[attc]["ctl2Display"] }}>
                <FormItem colon={false} labelCol={{ span: 23 }} label={"-----"} />
            </Col> */}
			{ctl2ShowFlg ?
				<Col span={1} >
					<div style={{ textAlign: "center", marginTop: 9 }}>~</div>
				</Col>
				: null}
			{ctl2ShowFlg ?
				<Col span={5} style={{ display: this.state.formsValue[attc]["ctl2Display"] }}>
					<div style={{ ...moveStyle, float: "left", width: "100%" }}>{ctl2}</div>
				</Col>
				: null}
			{/* <Col span={1} style={{ display: ctl2ShowFlg ? undefined : "none" }}>
                <FormItem colon={false} labelCol={{ span: 23 }} label="--" />
            </Col>
            <Col span={6} style={{ display: this.state.formsValue[attc]["ctl2Display"] }}>
                {ctl2}
            </Col> */}
		</Row>
	}

	refModalFunction(ctl) {
		if (!ctl) {
			return;
		}
		let { moduleDesc, objFct } = ctl.props;
		this.state.showCtls[moduleDesc.cRef + moduleDesc.c] = ctl;
	}

	renderCardNodes = (data, forms) => {

		return data.map((item, index, arr) => {
			if (item.cldSet) {
				let cardDisplay = 'none';
				let tmpItem;
				for (var i = 0; i < item.cldSet.length; i++) {
					tmpItem = item.cldSet[i];
					if (forms[tmpItem.c]) {
						cardDisplay = undefined;
						break;
					}
				}
				return (
					<Card size="small" title={item.te} style={{ display: cardDisplay, border: 0 }}>
						{this.renderCardNodes(item.cldSet, forms)}
					</Card>
				);
			} else {
				return forms[item.c] ? (<Col span={12}>{forms[item.c]}</Col>) : null;
			}
		});

	}

	render() {

		const { allData, forms } = this.state;

		return (
			<div style={{ height: '100%', width: '100%' }}>
				<Row style={{ height: '100%', width: '100%' }}>
					<Col style={{ height: '100%' }} span={24}>
						{this.renderCardNodes(allData, forms)}
					</Col>
				</Row>
			</div >
		)

	}

	componentDidMount() {
		const { data, allData } = this.state;
		if (data && data.length > 0) {
			this.refreshData(data);
		}
	}
}


// WEBPACK FOOTER //
// ./apps/pages/paramMng/CustQueryCondition.js